import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

interface ISeleccionRolloModalProps {
  showSeleccion: boolean;
  toggleSeleccion: () => void;
  onClickScan: () => void;
  onClickManual: (manualValue: string) => void;
  seleccion?: { key: number; value: string };
}
const SeleccionRolloModal = (props: ISeleccionRolloModalProps) => {
  const {
    showSeleccion,
    toggleSeleccion,
    onClickScan,
    onClickManual,
    seleccion,
  } = props;

  const [manualValue, setManualValue] = useState("");

  useEffect(() => {
    setManualValue("");
  }, [showSeleccion]);

  const manejarInput = (e: any) => {
    const result = e.target.value.replace(/\D/g, "");

    setManualValue(result);
  };

  const isValidCode = (): boolean => {
    return manualValue.length === 11 && !isNaN(parseInt(manualValue));
  };
  return (
    <div>
      <Modal isOpen={showSeleccion} toggle={toggleSeleccion}>
        <ModalHeader toggle={toggleSeleccion}>
          {seleccion?.value ? `Rollo ID ${seleccion.value}` : "Escanear rollo"}
        </ModalHeader>
        <ModalBody>
          <label htmlFor="codigoRollo">Código de rollo</label>
          <input
            type="text"
            maxLength={11}
            className="form-control"
            id="codigoRollo"
            onChange={manejarInput}
            value={manualValue}
          />
        </ModalBody>
        <ModalFooter>
          <div>
            <button
              className="btn btn-primary btn-rounded btn-block"
              type="button"
              onClick={onClickScan}
            >
              Escanear
            </button>
            <button
              className="btn btn-success btn-rounded btn-block"
              type="button"
              disabled={!isValidCode()}
              onClick={() => {
                onClickManual(manualValue);
              }}
            >
              Ingreso Manual
            </button>
          </div>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default SeleccionRolloModal;
